import { render, staticRenderFns } from "./RegisterIntegrate.vue?vue&type=template&id=47bbd07c&scoped=true&"
import script from "./RegisterIntegrate.vue?vue&type=script&lang=js&"
export * from "./RegisterIntegrate.vue?vue&type=script&lang=js&"
import style0 from "./RegisterIntegrate.vue?vue&type=style&index=0&id=47bbd07c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bbd07c",
  null
  
)

export default component.exports